import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=78eadb1e&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eadb1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78eadb1e')) {
      api.createRecord('78eadb1e', component.options)
    } else {
      api.reload('78eadb1e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=78eadb1e&scoped=true", function () {
      api.rerender('78eadb1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/tenantPackage/edit.vue"
export default component.exports